import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /* ------------------------------------*\
    #PRIMARY NAV
\*------------------------------------ */
/**
 * 1) Primary navigation of the site. This should only used within the header component
 */
/**
 * Actual web component wrapper
 * 1) Used to help with the priority plus more behavior for the width
 */
:host {
  flex: 1; /* 1 */
  max-width: 100%;
  overflow: hidden;
}

:host([isMobile]) {
  flex: none;
  overflow: visible;
}

:host([panelOpen]) {
  overflow: visible;
}

/**
 * Primary navigation
 */
.cat-c-primary-nav {
  --cat-list-item-background-color: transparent;
  display: flex;
  width: auto;
}
.cat-c-primary-nav.cat-is-mobile {
  display: none;
}
.cat-c-primary-nav.cat-is-mobile.cat-is-collapsed {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: var(--cat-primary-nav-positon-top-mobile, calc(var(--size-base-unit) * 7));
  background: var(--cat-theme-color-background-xstrong);
  z-index: var(--cat-z-index-300);
  height: var(--cat-primary-nav-height-mobile, calc(100vh - (var(--size-base-unit) * 7)));
  overflow: auto;
  --cat-side-menu-item-panel-list-item-body-margin-inline-start: calc(var(--size-base-unit) * 3);
  --cat-list-item-link-hover-background: var(--cat-theme-color-background-xstrong-hover);
  --cat-list-item-link-font-color: var(--cat-theme-color-content-knockout);
  --cat-heading-color-content: var(--cat-theme-color-content-knockout);
}

/**
 * Primary nav list
 * 1) Stack on small screens within the toggleable menu but place side by side on large screens
 */
.cat-c-primary-nav__list {
  display: flex;
  flex-direction: column; /* 1 */
  margin: 0;
  padding: 0;
  list-style: none;
}
.cat-c-primary-nav:not(.cat-is-mobile) .cat-c-primary-nav__list {
  flex-direction: row; /* 1 */
}
.cat-c-primary-nav__list ::slotted(cat-primary-nav-item) {
  width: 100%;
}
.cat-c-primary-nav--full-width .cat-c-primary-nav__list {
  width: var(--cat-primary-nav-item--full-width, 100%);
}

.cat-c-primary-nav__more {
  display: none;
  /**
   * Subnav more list within collapsed subnav nav
   * 1) Show "more" button with dropdown
   */
}
.cat-c-primary-nav__more.cat-is-collapsed {
  display: none;
}
.cat-c-primary-nav:not(.cat-is-mobile) .cat-c-primary-nav__more.cat-is-collapsed {
  display: block; /* 1 */
}

/**
  * Slotted hidden class
  * 1) Hide the item from the viewer
  */
.cat-c-primary-nav:not(.cat-is-mobile) ::slotted(.cat-is-hidden) {
  display: none;
}

/**
 * Subnav more list
 */
.cat-c-primary-nav__more-list {
  display: none;
  list-style: none;
  margin: 0 calc(var(--size-base-unit) * 1) 0 0;
  padding: 0;
}
.cat-c-primary-nav:not(.cat-is-mobile) .cat-c-primary-nav__more-list {
  margin-inline-start: auto;
}

/**
 * Subnav more dropdown item
 * 1) Hide until visible class is added
 * 2) TODO Rename
 */
.cat-c-primary-nav__more-dropdown-item {
  display: none; /* 1 */
}

/**
 * Visible Subnav more dropdown item
 * 1) Show item when visible class is added
 * 2) TODO Rename
 */
.cat-c-primary-nav__more-dropdown-item.cat-is-visible {
  display: block;
}

.cat-c-primary-nav__more-dropdown {
  list-style: none;
  margin: 0;
  padding: 0;
}
.cat-c-primary-nav__more-dropdown cat-primary-nav-item {
  display: content;
}

.cat-c-primary-nav__dropdown-link {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  display: block;
  width: 100%;
  appearance: none;
  border: none;
  outline: none;
  padding: calc(var(--size-base-unit) * 1);
  background: none;
  text-align: start;
  text-decoration: none;
  color: var(--cat-theme-color-content-default);
  border-radius: var(--cat-theme-border-radius);
  cursor: pointer;
  transition: background var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-primary-nav__dropdown-link:hover, .cat-c-primary-nav__dropdown-link:focus {
  background: var(--cat-theme-color-background-subtle);
}

.cat-c-primary-nav__sublist {
  white-space: nowrap;
}
`;
       